<app-welcome-page pageName="Login" (buttonClicked)="login($event)">
  @if (false) {
    <span>
      No account? Go to
      <a mat-button routerLink="/signup" color="primary">Sign Up</a>
      .
    </span>
  }
</app-welcome-page>
